import * as types from "../Actions/Types";
import { StoreExploreData } from "../Models/IStoreExploreData";
import { IStoreType, ITwoByTwo } from "../Models/Models";
import { regionNames } from "../Components/Apps/Network Audit/constants";

export interface ITwoByTwoState {
  data: ITwoByTwo;
  store: StoreExploreData;
}

const processTwoByTwoData = (data) => {
    const iHaveNoIdeaWhatThisNumberIs = 16777215;
    const hexLength = 7;

    for (let i = 0; i < data.buds.length; i++) {
        let hexColor
      = "#"
      + Math.floor(Math.random() * iHaveNoIdeaWhatThisNumberIs).toString(16);
        hexColor = hexColor.length === hexLength ? hexColor : hexColor + 0;
        data.buds[i] = {
            type: "BUDS",
            name: "BUDS " + data.buds[i],
            value: data.buds[i],
            hexColor: hexColor,
            displayColorPicker: false,
        };
    }

    for (let i = 0; i < data.storeTypes.length; i++) {
        const type = data.storeTypes[i] as IStoreType;
        let hexColor
      = "#"
      + Math.floor(Math.random() * iHaveNoIdeaWhatThisNumberIs).toString(16);
        hexColor = hexColor.length === hexLength ? hexColor : hexColor + 0;
        type.hexColor = hexColor;
        type.displayColorPicker = false;
        type.type = "LOCATIONS";
        data.storeTypes[i] = type;
    }

    for (let i = 0; i < data.regions.length; i++) {
        let hexColor
      = "#"
      + Math.floor(Math.random() * iHaveNoIdeaWhatThisNumberIs).toString(16);
        hexColor = hexColor.length === hexLength ? hexColor : hexColor + 0;
        data.regions[i] = {
            type: "REGION",
            name: regionNames[data.regions[i]],
            value: data.regions[i],
            hexColor: hexColor,
            displayColorPicker: false,
        };
    }
    data.models = [];
    for (const item in data.dict) {
        if (item !== undefined) {
            let hexColor
        = "#"
        + Math.floor(Math.random() * iHaveNoIdeaWhatThisNumberIs).toString(16);
            hexColor = hexColor.length === hexLength ? hexColor : hexColor + 0;
            data.models.push({
                type: "MODEL",
                name: item,
                value: data.dict[item],
                hexColor: hexColor,
                displayColorPicker: false,
            });
        }
    }
};

export const twoByTwo = (
    state: ITwoByTwoState = { data: null, store: new StoreExploreData() },
    action
): ITwoByTwoState => {
    switch (action.type) {
        case types.LOAD_TWO_BY_TWO_SUCCESS: {
            processTwoByTwoData(action.data);

            return {
                ...state,
                data: action.data,
            };
        }

        case types.EXPLORE_STORE_SUCCESS: {
            return {
                ...state,
                store: action.data,
            };
        }

        default:
            return state;
    }
};
